export const capabilities = [
  'ALZHEIMER_CAPABILITIES',
  'APOTTI_MEDICATION_UPDATE',
  'APPOINTMENTS',
  'APPOINTMENTS_CREATE',
  'CLINICAL_RECORDS',
  'DMD_MYSERVICE_TILE',
  'DMD_RECORD_TOI',
  'DMD_RECORD_FYST',
  'DMD_RECORD_LNEU',
  'EDITLOG_DELETELOG_VIEW',
  'EPILEPSY_MYSERVICE_TILE',
  'EPILEPSY_RECORD_NEU',
  'FIMLAB_LABORATORY_SYNC',
  'LFORCE_IMAGING_SYNC',
  'LIFECARE_DIAGNOSIS_SYNC',
  'LIFECARE_LABORATORY_SYNC',
  'LIFECARE_MEDICATION_SYNC',
  'MEDICATION_CREATE',
  'MEDICATION_CREATE_RETROSPECTIVE',
  'MGRAVIS_MYSERVICE_TILE',
  'MIRANDA_MEDICATION_UPDATE',
  'MYSERVICE_INTEGRATION',
  'MYSERVICE_SURVEYS_DELETION',
  'MYSERVICE_TILE',
  'NINMT_MYSERVICE_TILE',
  'NINMT_RECORD_HOI',
  'NINMT_RECORD_RADU',
  'NMOSD_CAPABILITES',
  'PARKINSON_MYSERVICE_TILE',
  'PARKINSON_RECORD_HOI',
  'PARKINSON_RECORD_NEU',
  'PATIENT_PROFILE_EDIT',
  'PATIENT_TRANSFER_INITIATE',
  'RESMED_AVX_INTEGRATION',
  'SLEEPAPNEA_RECORD_HOI',
  'SLEEPAPNEA_RECORD_KEU',
  'SMA_MYSERVICE_TILE',
  'SMA_RECORD_FYST',
  'SMA_RECORD_LNEU',
  'SMA_RECORD_TOI',
  'SR_MYSERVICE_TILE',
  'URANUS_CARETABLE_SYNC',
] as const;

export const platforms: Array<TPlatform> = [
  'sma',
  'dmd',
  'parkinson',
  'ms',
  'huntington',
  'epilepsy',
  'sleepApnea',
  'ninmt',
  'mgravis',
  'polyneuro'
];
